import { render, staticRenderFns } from "./FomrStep_Refugium.vue?vue&type=template&id=5dd0cc28&scoped=true&"
import script from "./FomrStep_Refugium.vue?vue&type=script&lang=js&"
export * from "./FomrStep_Refugium.vue?vue&type=script&lang=js&"
import style0 from "./FomrStep_Refugium.vue?vue&type=style&index=0&id=5dd0cc28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd0cc28",
  null
  
)

export default component.exports